export class RoleModel {
    id: number;
    name: string;
    vehicles: Array<any>;

    constructor () {
        this.id = 0;
        this.name = '';
        this.vehicles = [];
    }

    public static fromJson (data: any): RoleModel {
        const role = new RoleModel;
        Object.assign(role, {
            id: data.id,
            name: data.name,
            vehicles: data.vehicle_types
        })

        return role;
    }
}